import { type StaffRole, staffRoles } from "@lafayette/auth";
import { usePermissions } from "@refinedev/core";

import { getAdminPublicConfig } from "../config/public-config";

/**
 * The staff roles of the session, from the auth provider (the trusted `/staff/session` answer in a real build). This is the ONE place that
 * reads them: the shell, the route guard, every capability hook and the offering ask it. While they load, `isLoading` is true and `roles`
 * is empty. The development placeholder falls back to its configured role.
 */
export function useStaffRoles(): Readonly<{ roles: readonly StaffRole[]; isLoading: boolean }> {
  const { data, isLoading } = usePermissions<StaffRole[]>({ params: {} });
  const config = getAdminPublicConfig();
  const trusted = (data ?? []).filter((permission): permission is StaffRole =>
    staffRoles.includes(permission),
  );
  const roles =
    trusted.length > 0
      ? trusted
      : config.developmentAuthPlaceholderEnabled
        ? [config.developmentStaffRole]
        : [];
  return { roles, isLoading };
}
